import { isEmpty, startCase } from "lodash-es"
import React from "react"
import CustomTag from "components/Atoms/CustomTag"
import { useFilter } from "store/search-filter/search-filter.reducer"

const ActiveFilters = () => {
  const [filter, setFilter] = useFilter("vendors")

  function handleChange(f) {
    setFilter({
      ...filter,
      [f]: undefined,
    })
  }
  return (
    <div className="rg-vendor-active-fitlers">
      {isEmpty(filter)
        ? "No Filters applied!"
        : Object.keys(filter)
            .filter(f => filter[f])
            .map((f, idx) => (
              <CustomTag
                intent="success"
                minimal
                className={"mr-2"}
                interactive={f !== "group"}
                key={f}
                onRemove={f === "group" ? undefined : () => handleChange(f)}
              >
                {`${startCase(f)} - ${filter[f]?.name}`}
              </CustomTag>
            ))}
    </div>
  )
}

export default ActiveFilters
